import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Collapse from 'react-bootstrap/Collapse';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashCan } from '@fortawesome/free-regular-svg-icons';

const Fabrication = ({ quantity, unitPrice, leadTime, subTotal, selected, cleanUp }) => {
  const [open, setOpen] = useState(false);

  if (!selected) return null;

  const onDelete = () => {
    cleanUp()
    setOpen(false);
  };
  const onToggle = () => setOpen(!open);

  return (
    <div className="cart-section fabrication">
      <div className="title">
        PCB Fabrication
        <button type="button" onClick={onDelete} className="btn btn-link float-end btn-delete">
          <FontAwesomeIcon icon={faTrashCan} />
        </button>
      </div>
      <div className="position-relative">
        <div className="price">{subTotal !== undefined ? `$${subTotal}` : null}</div>
        <div className="toggle-details">
          <button type="button" className="btn btn-link p-0" onClick={onToggle}>
            {`${open ? 'LESS' : 'VIEW MORE'}`} 
          </button>
        </div>
        <Collapse in={open}>
          <div>
            <div className="details">
              <div className="detail">
                <strong>Lead Time:</strong> {leadTime}
              </div>
              <div className="detail">
                <strong>Quantity:</strong> {quantity}
              </div>
              <div className="detail">
                <strong>Unit Price:</strong> {unitPrice !== undefined ? `$${unitPrice}` : null}
              </div>
            </div>
          </div>
        </Collapse>
      </div>
    </div>
  )
};

Fabrication.propTypes = {
  quantity: PropTypes.number,
  unitPrice: PropTypes.number,
  leadTime: PropTypes.number,
  subTotal: PropTypes.number,
  selected: PropTypes.bool,
  cleanUp: PropTypes.func.isRequired,
}

export default Fabrication;
